import { player } from './api/entities';
import actions from './player_actions';

export function resetSpecificPlayer() {
  return { type: actions.resetSpecificPlayer };
}

export function resetPlayerState() {
  return { type: actions.resetPlayerState };
}

export function createPlayer(playerObject) {
  return player.create(actions.createPlayer, playerObject, []);
}

export function updatePlayer(playerId, playerObject) {
  return player.update(actions.updatePlayer, playerId, playerObject, []);
}

export function getPlayers(query, sort) {
  return player.list(actions.listPlayer, query, sort);
}

export function getPlayer(playerId) {
  return player.get(actions.getPlayer, playerId, []);
}

const INITIAL_STATE = {
  players: [],
  player: {},
  assigned_players: [],
  retrieved_players: false,
  retrieved_assigned_players: false,
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.resetPlayerState:
      return {
        ...INITIAL_STATE,
      };
    case actions.createPlayer:
      return {
        ...state,
        players: action.body ? [...state.players, action.body] : state.players,
      };
    case actions.listPlayer:
      return {
        ...state,
        players: action.body ? action.body._items : state.players,
      };
    case actions.getPlayer:
      return {
        ...state,
        player: action.body ? action.body : state.player,
      };
    case actions.updatePlayer:
      return {
        ...state,
        id: action.body ? action.body : null,
      };
    case actions.assignedPlayers:
      return {
        ...state,
        assigned_players: action.assigned_players ? action.assigned_players : state.assigned_players,
        retrieved_assigned_players: true,
      };
    case actions.getMyPlayers:
      return {
        ...state,
        owned_players: action.players_data ? action.players_data : state.players,
        retrieved_players: true,
      };
    case actions.getSpecificPlayer:
      return {
        ...state,
        specific_player: action.specific_player,
      };
    case actions.resetSpecificPlayer:
      return {
        ...state,
        specific_player: false,
      };
    default:
      return {
        ...state,
      };
  }
}
